document.addEventListener("DOMContentLoaded", () => {
	let button = document.getElementById("load-more-posts");
	let postsContainer = document.getElementById("extra-posts-container");

	if (!button || !postsContainer) return;

	button.addEventListener("click", () => {
		const offset = parseInt(button.dataset.offset) || 0;
		const categoryId = button.dataset.categoryId || "";
		const isCategory = button.dataset.isCategory || "0";
		const authorId = button.dataset.authorId || "";
		const newsAuthorId = button.dataset.newsAuthorId || "";

		const formData = new FormData();
		formData.append("action", "load_more_posts");
		formData.append("offset", offset);
		formData.append("category_id", categoryId);
		formData.append("is_category", isCategory);
		formData.append("author_id", authorId);
		formData.append("news_author_id", newsAuthorId);

		fetch(ajax_object.ajax_url, {
			method: "POST",
			body: formData,
		})
			.then((response) => response.json())
			.then((response) => {
				if (response.success && response.data) {
					const html = response.data.html || "";
					const count = response.data.count || 0;
					const hasMore = response.data.has_more !== false;

					if (html.trim() !== "" && count > 0) {
						postsContainer.insertAdjacentHTML("beforeend", html);
						button.dataset.offset = offset + count;

						if (!hasMore) {
							button.remove();
						}
					} else {
						button.remove();
					}
				} else {
					button.remove();
				}
			})
			.catch((error) => {
				console.error("Ошибка загрузки:", error);
				button.remove();
			});
	});
});
